<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div class="absolute h-[calc(100%-140px)] w-540px left-35px top-66px z-100">
    <el-tooltip
      :content="showPanel ? '收缩防腐保温' : '展开防腐保温'"
      placement="right"
      :open-delay="1000"
    >
      <div
        class="w-34px h-34px rounded-tl-2px rounded-tr-5px rounded-br-5px
          rounded-bl-2px bg-[#00c0ff] top-0px -left-34px text-center
          cursor-pointer absolute text-[#fff]"
        @click="showPanel = !showPanel"
      >
        <span class="iconfont icon-bg-setup text-18px !leading-34px"></span>
      </div>
    </el-tooltip>
    <div class="p-10px component-container h-full" v-show="showPanel">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        防腐保温
      </div>
      <div class="flex">
        <selectStandardId
          @updateStandardId="updateStandardId"
          class="!w-140px"
          :selectStandardProps="{ popperClass: 'document_select-popper' }"
        />
        <el-select
          class="w-full ml-10px flex-1"
          v-model="modelDocumentId"
          popper-class="document_select-popper"
          clearable
          filterable
          size="mini"
          placeholder="模型下拉选择"
          @change="changeCurrentModel"
        >
          <el-option
            v-for="item in modelList"
            :key="item.id"
            :label="item.fileNameOrigin"
            :value="item.documentId"
          ></el-option>
        </el-select>
      </div>
      <div class="flex mt-10px items-center">
        <el-input
          v-model="keyword"
          size="mini"
          class="mr-10px !w-140px"
          placeholder="请输入代码或名称"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-input
          v-model="discipline"
          size="mini"
          class="mr-10px flex-1"
          placeholder="请输入专业"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="searchList"
            icon="iconfont icon-line-search"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="对象信息" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="$emit('showBitRelational')"
            icon="iconfont icon-bg-language"
          ></el-button>
        </el-tooltip>
      </div>
      <div class="px-10px flex items-center text-[#fff] text-12px">
        <span class="mr-10px">透明度</span>
        <el-slider
          v-model="colorPickupBkAlpha"
          :min="0"
          :max="1"
          :step="0.1"
          class="w-full flex-1"
        />
      </div>
      <el-table
        ref="markerTable"
        :data="tableData"
        v-loading="tableLoading"
        height="calc(100% - 216px)"
        :row-key="(row) => row.tagId"
        class="mt-10px"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="true"
        @row-click="moveToPipe"
      >
        <el-table-column show-overflow-tooltip prop="tagCode" label="代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagName" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="medium" label="介质"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="discipline" label="专业"></el-table-column>
      </el-table>
      <div class="mt-10px text-right">
        <el-pagination
          small
          background
          @current-change="getTableData"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ThreeDimensionsService from '@/services/ThreeDimensions'
import ApiMixinDocument from '@/assets/js/api/documents'
import selectStandardId from '@/modules/resource/components/selectStandardId'

export default {
  name: 'anticorrosionInsulation',
  mixins: [ApiMixinDocument],
  components: {
    selectStandardId,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showPanel: true,
      standardId: localStorage.getItem('standardId'),
      modelDocumentId: '',
      modelList: [], // 模型列表
      keyword: '',
      discipline: '',
      allModelList: [], // 所有模型列表
      colorPickupBkAlpha: 0.7,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      currentRow: null,
    }
  },
  watch: {
    colorPickupBkAlpha: {
      async handler(val) {
        await this.renderVignette(val)
      },
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.resetData()
      this.getTableData()
    },
    // 获取管线表数据
    async getTableData() {
      this.tableData = []
      this.tableLoading = true
      const res = await ThreeDimensionsService.getPipeLineList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        standardId: this.standardId,
        modelFileId: this.modelDocumentId
          ? _.find(this.modelList, ['documentId', this.modelDocumentId]).fileIdOrigin
          : '',
        filter: this.keyword,
        discipline: this.discipline,
      })

      if (res?.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 重置数据
    async resetData() {
      this.tableData = []
    },
    updateStandardId(val) {
      this.standardId = val
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    },
    // 切换模型
    async changeCurrentModel(val) {
      // 获取model详情
      const model = await this.getModelFileDetail(val)
      if (!_.isEmpty(model)) {
        this.$emit('changeModelData', model)
      }
      this.searchList()
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getModelFileDetail(id) {
      const res = await DocumentManagementService.getDocumentDetail({
        id,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        if (_.isEmpty(fileDetail)) {
          return {}
        }
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        fileDetail.classId = res.data.documentBaseInfo.classId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.last(_.split(fileDetail.fileName, '.')).toLowerCase()
        return fileDetail
      }
      return {}
    },
    async getModelList() {
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          id: this.documentId,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data
      }
      return []
    },
    async markerHover(item) {
      const newimgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,127')
      if (item.markerId !== 0) {
        await this.player.Native.GisMarker.setProperty(item.markerId, {
          imgId: newimgId,
          textColor: 0xffffffff,
        })
      }
    },
    async markerLeave(item) {
      // 创建一个透明的图片，用于隐藏
      const imgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,0')
      await this.player.Native.GisMarker.setProperty(item.markerId, {
        imgId,
        textColor: 0xffffff00,
      })
    },
    async renderVignette(val) {
      if (_.isEmpty(this.player)) return
      // 调整alpha通道值
      await this.player.Native.Setting.set('display.bgTransparent.alpha', val)
      // 选中表格中选择的模型节点
      if (!this.currentRow) return
      const rootNode = await this.player.Native.Node.getRoot()
      if (!rootNode) return
      const codeInfoCol = await this.player.Native.Node.findNode(rootNode, {
        codes: [this.currentRow.tagCode],
      })
      if (codeInfoCol?.codes && !_.isEmpty(codeInfoCol.codes)) {
        const nodeCol = _.map(Object.values(codeInfoCol.codes), 'node')
        await this.player.Native.Node.selectNodes(nodeCol)
      }
    },
    async moveToPipe(row) {
      await this.cloudRender.Marker.destroyAllMarker()
      this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
      this.player.Native.GisMarker.EventGisMarkerLeave.disconnect(this.markerLeave)
      if (row.tagCode) {
        this.currentRow = row
        this.$emit('getModelData', {
          isTag: true,
          businessId: row.tagId,
          code: row.tagCode,
          codeChangeType: 'pickUpengineId', // 避免触发ModelView中的moveCamera，动画节点会覆盖原始节点导致选中不生效
        })
        this.$emit('showRightPanel', {
          component: 'anticorrosionInsulationDetail',
          transferProps: {
            ...row,
          },
        })
        await this.player.Native.Setting.set('display.bgTransparent.enable', true)
        await this.player.Native.Setting.set('display.bgTransparent.alpha', this.colorPickupBkAlpha)
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.tagCode],
        })
        const codes = codeData?.codes
        if (codes && codes[row.tagCode] && codes[row.tagCode].node) {
          // 计算节点包围盒
          const nodeInfo = await this.player.Native.Node.getProperty(codes[row.tagCode].node, [
            'aabb',
          ])
          const calculateValue = (aabb) => {
            const minPoint = aabb[0]
            const maxPoint = aabb[1]

            const dx = maxPoint[0] - minPoint[0]
            const dy = maxPoint[1] - minPoint[1]
            const dz = maxPoint[2] - minPoint[2]

            const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
            const value = 0 + 6.5 / (1 + Math.log(L + 1))
            return value
          }
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithDistance(
            nodeInfo.aabb,
            2,
            25,
            calculateValue(nodeInfo.aabb)
          )
          this.player.Native.Node.selectNodes([codes[row.tagCode].node])
          this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
          this.player.Native.GisMarker.EventGisMarkerLeave.connect(this.markerLeave)
          const nodeResult = await this.cloudRender.NodeProxy.getInfo('Code', row.tagCode)
          if (nodeResult.status) {
            const nodeData = nodeResult.data.nodeInfo
            const text = `Code: ${nodeData.code}`
            const aabb = nodeData.aabb
            const pos = []
            pos[0] = aabb[0][0] + (aabb[1][0] - aabb[0][0]) * 0.5 // x坐标
            pos[1] = aabb[0][1] + (aabb[1][1] - aabb[0][1]) * 0.5 // y坐标
            pos[2] = aabb[0][2] + (aabb[1][2] - aabb[0][2]) // z坐标
            await this.cloudRender.Marker.createBySingleLine({
              id: row.tagCode,
              pos,
              background: 'transparent',
              visible: true,
              text,
              textColor: '#ffffffff',
              nodeOffset: [0, -60],
              markPosType: 1,
            })
          }
        }
      }
    },
  },
  async created() {
    this.allModelList = await this.getModelList()
    if (this.standardId) {
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    }
  },
  async beforeDestroy() {
    const rootNode = await this.player.Native.Node.getRoot()
    if (rootNode) {
      await this.player.Native.Node.setProperty(rootNode, { visible: true })
    }
    this.player.Native.Setting.set('display.bgTransparent.enable', false)
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}

</style>
